<template>
    <a :href="target" class="wishlist js-ga-event" id="wishlistBtn"
       data-page-area="header"
       data-type="link"
       data-name="wishlist"
       data-action="href"
       :data-destination-url="target"
    >
        <Popper :content="ttText" hover arrow id="js-wishlist-icon">
            <img src="/img/icons/heart.svg" v-svg-inline>
        </Popper>
        <span class="count" id="wishlistItemCounter">{{ prodQuantity }}</span>
    </a>
</template>

<script>
import Popper from 'vue3-popper'

import { reactive, toRefs, inject, onMounted } from 'vue'

export default {

    props: [
        'target',
        'tooltipText',
        'quantity'
    ],

    components: {
        Popper
    },

    setup(props) {

        const emitter = inject('emitter')

        const state = reactive({
            prodQuantity: 0,
            ttText: "",
        })

        onMounted( () => {
            state.prodQuantity = props.quantity
            state.ttText = props.tooltipText + state.prodQuantity
            emitter.on('on-wishlist-count-change', (count) => {
                //state.prodQuantity = count
                state.ttText = props.tooltipText + count
            })
        })

        return {
            ...toRefs(state)
        }
    }
}
</script>
